<template>
  <transition name="modal">
    <div class="modalcon">
      <div class="modal-mask" @click="$emit('close')">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop tabindex="0" @keydown="handleKeydown" ref="modalContainer">
            <div class="modal-body">
              <button class="btn closebtn" @click="$emit('close')">X</button>
              <carousel :perPage='1' :navigationEnabled="true" :paginationEnabled="false" :autoplay="false"
                navigationNextLabel=" " navigationPrevLabel=" " class="magnifyimg zoom-carousel" ref="magnifyCarosel"
                :speed="0">
                <slide v-for="(img, index) in imgslide" :key="index">
                  <VideoPlayer
                    v-if="img.includes('%video%')"
                    :src="img.split('%video%')[0]"
                    :poster="img.split('%video%')[1]"
                    :playVideo="true"
                  />
                  <div v-else>
                    <div v-if="isDesktop" @mousemove="mouseMove">
                      <img style="cursor: zoom-in;" :class="{'disNone': showZoom}" :data-src="prodImgPath+img" :alt="img"/>
                      <zoom-on-hover style="cursor: zoom-in;" :class="{'disNone': !showZoom}" :img-normal="prodImgPath+img" :scale="2"></zoom-on-hover>
                    </div>
                    <div class="zoom-mobile" v-else>
                      <zoom-on-hover style="cursor: zoom-in;" :img-normal="prodImgPath+img" :scale="2"></zoom-on-hover>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import {Carousel, Slide} from 'vue-carousel'
  import VideoPlayer from '../common/VideoPlayer.vue'
  export default {
    props: ['imgArray', 'activeImg', 'videoUrl', 'isDesktop'],
    data () {
      return {
        selectImage: this.activeImg,
        prodImgPath: process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG,
        showZoom: false
      }
    },
    methods: {
      mouseMove () {
        this.showZoom = true
      },
      nextSlide () {
        this.$refs.magnifyCarosel.goToPage(
          (this.$refs.magnifyCarosel.currentPage + 1) % this.imgslide.length
        )
      },
      prevSlide () {
        const prevPage = this.$refs.magnifyCarosel.currentPage === 0 ? this.imgslide.length - 1
         : this.$refs.magnifyCarosel.currentPage - 1
        this.$refs.magnifyCarosel.goToPage(prevPage)
      },
      handleKeydown (event) {
        if (event.key === 'ArrowRight') {
          this.nextSlide()
        } else if (event.key === 'ArrowLeft') {
          this.prevSlide()
        }
      },
      mouseMoveMobileHandler () {
        let elem = document.getElementsByClassName('zoom-mobile')
        // Define variable
        let pressTimer = null
        // Define funtion handlers
        // Create timeout ( run function after 350ms )
        let start = (e) => {
          if (e.type === 'click' && e.button !== 0) {
            return
          }
          e.preventDefault()
          e.stopPropagation()
          if (pressTimer === null) {
            pressTimer = setTimeout(() => {
              // Run function zoom
              this.mouseMove()
            }, 350)
          }
        }
        // Cancel Timeout
        let cancel = (e) => {
          // Check if timer has a value or not
          if (pressTimer !== null) {
            clearTimeout(pressTimer)
            pressTimer = null
          }
        }
        if (elem) {
          Array.from(elem).forEach(el => {
            // Add Event listeners
            el.addEventListener('mousedown', start)
            el.addEventListener('touchstart', start)
            // Cancel timeouts if this events happen
            el.addEventListener('click', cancel)
            el.addEventListener('mouseout', cancel)
            el.addEventListener('touchend', cancel)
            el.addEventListener('touchcancel', cancel)
          })
        }
      }
    },
    mounted () {
      this.$refs['magnifyCarosel'].currentPage = this.activeImg
      this.$refs.modalContainer.focus()
      this.isDesktop ? '' : this.mouseMoveMobileHandler()
    },
    components: {Carousel, Slide, VideoPlayer},
    computed: {
      imgslide () {
        var b = {}
        if (this.videoUrl.includes('%video%')) {
          b = [this.videoUrl]
          return b
        } else if (this.imgArray) {
          b = [...this.imgArray]
          b.unshift(b.splice(this.activeImg, 1).pop()) // active image is put at the start of array
          return b
        } else {
          return b
        }
      }
    }
  }
</script>
<style scoped="scoped">

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 9998;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .disNone {
    display: none;
  }

  .closebtn {
    font-weight: bold;
    cursor: pointer;
    position: absolute;
    right: 25px;
    top: 25px;
    z-index: 999;
    background-color: #ffffff;
    outline: none;
    color: #58595b;
    border-radius: 5px;
    padding: 1px 12px;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.46);
    -moz-box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.46);
    box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.46);
  }


  .closebtn:hover {
    background-color: #e6e6e6;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 50%;
    margin: 0px auto;
    padding: 0px;
    border-radius: 2px;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header {
    padding: 5px;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-footer {
    padding: 15px 5px 5px 5px;
  }

  .modal-body {
    margin: 0px 0 0px 0;
    padding: 0px;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      width: 85%;
    }
  }
</style>

<style>
  .zoom-carousel button.VueCarousel-navigation-next, .zoom-carousel button.VueCarousel-navigation-prev {
    background-color: #ffffff;
    width: 35px;
    height: 35px;
    outline: none;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.46);
    -moz-box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.46);
    box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.46);
  }

  .zoom-carousel button.VueCarousel-navigation-next:before {
    right: 11px !important;
    top: 1px;
    color: #58595b;
    font-size: 30px;
  }

  .zoom-carousel button.VueCarousel-navigation-prev:before {
    left: 10px !important;
    top: 1px;
    color: #58595b;
    font-size: 30px;
  }

  .zoom-carousel button.VueCarousel-navigation-next {
    position: absolute;
    right: 62px;
  }

  .zoom-carousel button.VueCarousel-navigation-prev {
    position: absolute;
    left: 62px;
  }

  .zoom-carousel button.VueCarousel-navigation-next:focus, .zoom-carousel button.VueCarousel-navigation-prev:focus {
    outline: none;
  }

  .zoom-carousel button.VueCarousel-navigation-next:hover, .zoom-carousel button.VueCarousel-navigation-prev:hover {
    background-color: #e6e6e6;
  }
</style>




// WEBPACK FOOTER //
// productView.vue?7c35dc72